// pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PhoneEmailVerify from '../components/PhoneEmailVerify';
import PhoneSignIn from '../components/PhoneSignIn';

import { API_BASE } from '../config';

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const completeLogin = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify({ name: data.name, email: data.email, isAdmin: data.isAdmin }));
    navigate(data.isAdmin ? '/admin' : '/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Login failed');
        setLoading(false);
        return;
      }
      completeLogin(data);
    } catch (err) {
      setError('Server error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="page-narrow panel">
      <h2 className="display" style={{ fontSize: '22px', marginTop: 0 }}>Login</h2>
      {error && <p style={{ color: '#ff4757', fontSize: '13px' }}>{error}</p>}

      <form onSubmit={handleSubmit}>
        <label className="field-label">Email</label>
        <input type="email" name="email" className="input" value={formData.email} onChange={handleChange} required style={{ marginBottom: '12px' }} />

        <label className="field-label">Password</label>
        <input type="password" name="password" className="input" value={formData.password} onChange={handleChange} required style={{ marginBottom: '16px' }} />

        <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%' }}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <p style={{ textAlign: 'center', margin: '10px 0 0' }}>
        <Link to="/forgot-password" style={{ fontSize: '13px' }}>Forgot password?</Link>
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '20px 0' }}>
        <div style={{ flex: 1, height: '1px', background: 'var(--panel-border)' }} />
        <span className="muted" style={{ fontSize: '12px' }}>or</span>
        <div style={{ flex: 1, height: '1px', background: 'var(--panel-border)' }} />
      </div>

      <PhoneEmailVerify onVerified={completeLogin} onError={setError} />
      <div style={{ marginTop: '10px' }}>
        <PhoneSignIn onVerified={completeLogin} onError={setError} />
      </div>

      <p style={{ marginTop: '18px', textAlign: 'center', fontSize: '14px' }}>
        Don't have an account? <Link to="/signup">Sign up</Link>
      </p>
    </div>
  );
}

export default Login;
